<template>
  <div class="h-100">
    <calendar v-on:updateActiveDate="setActiveDate" :events="stats" :user="userProfile"></calendar>

    <v-layout v-if="activeStats" style="margin: 8px 0px" row wrap>
      <v-flex xs12>
         <v-list two-line id="stats-list">
          <v-list-tile @click="openSheet('Weight', activeStats.weight)">
            <v-list-tile-action>
              <v-icon color="primary">linear_scale</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Weight: {{activeStats.weight | displayWeight}}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-list-tile-sub-title>({{measurements.weight}})</v-list-tile-sub-title>
            </v-list-tile-action>
          </v-list-tile>

          <v-divider inset></v-divider>

          <v-list-tile @click="openSheet('Steps', activeStats.steps)">
            <v-list-tile-action>
              <v-icon color="primary">directions_walk</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Steps: {{activeStats.steps | ifNull}}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-list-tile-sub-title>(steps)</v-list-tile-sub-title>
            </v-list-tile-action>
          </v-list-tile>

          <v-divider inset></v-divider>

          <v-list-tile @click="openSheet('Calories', activeStats.calories)">
            <v-list-tile-action>
              <v-icon color="primary">restaurant_menu</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Calories {{activeStats.calories | ifNull}}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-list-tile-sub-title>(kcals)</v-list-tile-sub-title>
            </v-list-tile-action>
          </v-list-tile>

          <v-divider inset></v-divider>

          <v-list-tile v-if="goals.protein_percentage" @click="openSheet('Protein', activeStats.protein)">
            <v-list-tile-action>
              <v-icon color="primary">pie_chart</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title><span>Protein: {{activeStats.protein | ifNull}}</span><span v-if="activeStats.protein" class="caption"> (Kcals: {{activeStats.protein | totalKcals}})</span></v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-list-tile-sub-title>(grams)</v-list-tile-sub-title>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-flex>
      <v-flex v-if="userProfile.trial" xs12 class="text-xs-center">
        <v-list>
           <v-list-tile-action>
            </v-list-tile-action>
          <v-list-tile >
            <v-list-tile-content>
              <v-list-tile-title><h3 class="primary-text">You are currently a trial user!</h3></v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>

    <!-- <v-layout align-center justify-center row wrap style="height: calc(100% - 85px);">
      <v-flex xs12 class="text-xs-center">
        <v-btn round block color="primary" dark>Current Day #{{programmeProgress}} </v-btn> <br>
      </v-flex>
    </v-layout> -->

    <v-bottom-sheet id="stat-sheet" v-model="sheet" inset>
      <v-card class="primary" tile>
        <v-list>
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-sub-title>
               <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field
                    required
                    name="newStat"
                    :rules="rules"
                    v-model.number="newStat"
                    type="number"
                    solo
                    :placeholder="'Add ' + activeSheet"
                    ref="input"
                ></v-text-field>
               </v-form>
              </v-list-tile-sub-title>
            </v-list-tile-content>

            <v-spacer></v-spacer>

            <v-list-tile-action>
              <v-btn
              :loading="loading"
              @click.stop="submitStat"
              color="primary"
              >
                submit
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>
<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import { db } from '@/services/firebase'
import calendar from '@/components/partial/calendar-buttons.vue'
export default {
  components: {
    calendar
  },
  data () {
    return {
      stats: [],
      goals: {},
      defaultStats: {
        calories: null,
        weight: null,
        steps: null,
        protein: null
      },
      valid: true,
      rules: [
        v => !!v || 'Field is required',
        v => (v && !isNaN(v)) || 'Must be numerical'
      ],
      newStat: '',
      loading: false,
      dateContext: '',
      progress: 50,
      sheet: false,
      activeSheet: null,
      measurements: JSON.parse(localStorage.getItem('measureSystem'))
    }
  },
  mounted () {
    this.getStats()
    this.getGoals()
  },
  methods: {
    setActiveDate: function (date) {
      this.loading = true
      this.dateContext = moment(date).startOf('day').unix()
      this.loading = false
    },
    getStats: function () {
      var self = this
      db.collection('user_daily_stats').where('user_id', '==', self.currentUser)
        .onSnapshot(function (snapshot) {
          snapshot.docChanges().forEach(function (change) {
            if (change.type) {
              self.stats.push(change.doc.data())
            }
          })
        })
    },
    getGoals: function () {
      var self = this
      db.collection('user_goals').where('user_id', '==', self.currentUser)
        .onSnapshot(function (snapshot) {
          snapshot.docChanges().forEach(function (change) {
            if (change.type) {
              self.goals = change.doc.data()
            }
          })
        })
    },
    openSheet: function (stat, newStat) {
      this.sheet = true
      this.activeSheet = stat
      if (this.measurements.weight === 'lbs' && stat === 'Weight') {
        this.newStat = this.kgTolbs(newStat)
      } else {
        this.newStat = newStat
      }
      this.$nextTick(() => this.$refs.input.focus())
    },
    submitStat: function () {
      if (this.$refs.form.validate()) {
        this.loading = true
        this.setStats()
      }
    },
    lbsToKgs (value) {
      var kgs = (value / 2.205)
      return +kgs
    },
    kgTolbs (value) {
      var lbs = (value * 2.205)
      return +lbs.toFixed(2)
    },
    setStats: function () {
      var self = this
      var localMeasureSystem = JSON.parse(localStorage.getItem('measureSystem'))
      var stat = ''
      if (self.activeSheet === 'Weight' && localMeasureSystem.weight === 'lbs') {
        stat = self.lbsToKgs(self.newStat)
      } else {
        stat = self.newStat
      }
      var field = this.activeSheet.toLowerCase()
      var statRef = db.collection('user_daily_stats').doc(self.currentUser + '-' + this.dateContext)
      statRef.set({
        [field]: stat,
        created_at: self.dateContext,
        user_id: self.currentUser
      }, { merge: true })
        .then(function () {
          self.activeSheet = ''
        })
        .catch(function (error) {
          console.error('Error', error)
        })
      this.loading = false
      this.sheet = false
      this.newStat = ''
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      userProfile: 'userProfile'
    }),
    activeStats: function () {
      var self = this
      var filteredStats = self.stats.filter(function (stat) {
        var dateString = moment.unix(self.dateContext)
        return moment.unix(stat.created_at).isSame(dateString, 'day')
      })
      if (filteredStats.length > 0) {
        if (Array.isArray(filteredStats)) {
          return filteredStats[filteredStats.length - 1]
        } else {
          return filteredStats
        }
      } else {
        return this.defaultStats
      }
    },
    programmeProgress: function () {
      var currentDay = moment.unix(this.dateContext).dayOfYear()
      var startingDay = moment.unix(this.userProfile.commenced_at).dayOfYear()
      var diff = currentDay - startingDay
      return diff
    }
  }
}
</script>
<style scoped>
  .stat-card .v-icon {
    margin-right: 8px;
  }
  .stat-card .headline {
    padding-left: 16px;
  }
  .stat-card .right {
    padding-right: 8px;
    line-height: 28px;
  }
  .stat-card:hover {
    box-shadow: 0 0 6px rgba(15, 113, 67, 1);
  }
  .stat-card.active {
    box-shadow: 0 0 6px rgba(15, 113, 67, 1);
  }
  .flex {
    padding: 8px;
    margin-bottom: 16px;
  }
  .flex.border {
    border-right: 2px solid #E0E0E0;
  }
  #stats-list .v-list__tile__action {
    min-width: 40px!important;
  }
  #stats-list .v-divider--inset {
    margin-left: 50px;
    max-width: calc(100% - 50px);
  }
  .v-dialog.v-bottom-sheet {
    position: fixed;
    bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/members/homeViewAlt.vue